module.exports = __webpack_public_path__ + "_/_/src/demo/src/catalog/items/naspo/naspo.png";


//////////////////
// WEBPACK FOOTER
// ./src/demo/src/catalog/items/naspo/naspo.png
// module id = 600
// module chunks = 0